export const getNextSaturday = () => {
  const now = new Date();
  const day = now.getDay();
  const daysUntilSaturday = ((6 - day + 7) % 7) || 7;
  const nextSaturday = new Date(now);
  nextSaturday.setDate(now.getDate() + daysUntilSaturday);
  nextSaturday.setHours(23, 59, 59, 999);
  return nextSaturday;
};
